import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buy-tender-participation-thanks',
  templateUrl: './buy-tender-participation-thanks.component.html',
  styleUrls: ['./buy-tender-participation-thanks.component.css']
})
export class BuyTenderParticipationThanksComponent implements OnInit {

  title: string = 'GRAZIE';
  description: string = 'Grazie per aver acquistato la Partecipazione. La troverai nella tua area riservata, tra le Mie Partecipazioni.';

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    const error = localStorage.getItem('BUY_TENDER_PARTICIPATION_ERROR');
    if (error) {
      this.title = 'CI DISPIACE';
      this.description = error;
      console.log(error);
    }
  }

  goToMyParticipations() {
    this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'myParticipations' } });
    //window.open('/areariservata?tabToLoad=myParticipations','_self');
  }

}
